import script from "./ModalExclusion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalExclusion.vue?vue&type=script&setup=true&lang=ts"

import "./ModalExclusion.vue?vue&type=style&index=0&id=269b7b53&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-269b7b53"]])

export default __exports__